import PropTypes from "prop-types"

const PulseCheckAnswerShape = {
  questionAskedDate: PropTypes.instanceOf(Date),
  answerCount: PropTypes.number,
  answerValue: PropTypes.string,
}

export default PulseCheckAnswerShape



// WEBPACK FOOTER //
// ./src/state/shapes/PulseCheckAnswerShape.js